import styled from 'styled-components';

export const TableWrapper = styled.div`
	height: 100%;

	.ag-side-bar,
	.ag-root {
		border-bottom: none !important;
	}

	.ag-row-hover {
		.contextual-menu {
			visibility: visible;
		}
	}

	.ag-overlay-wrapper {
		background-color: rgba(255, 255, 255, 0.5);
	}
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

export const Footer = styled.div`
	display: flex;
	align-items: center;
	height: 48px;
	min-height: 48px;
	padding: 0 32px;

	> button:last-child {
		margin-left: auto;
	}
`;

export const LoadingWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const ContextualContent = styled.div`
	display: flex;
	flex-direction: column;
	width: 200px;
	padding-bottom: 8px;
`;
